import {
  INST_GROUPS_FOR_MAPPING_ERROR,
  INST_GROUPS_FOR_MAPPING_REQUEST,
  INST_GROUPS_FOR_MAPPING_SUCCESS,
  USER_GROUPS_FOR_MAPPING_ERROR,
  USER_GROUPS_FOR_MAPPING_REQUEST,
  USER_GROUPS_FOR_MAPPING_SUCCESS,
  ROLES_OF_USER,
  MAX_INSTRUMENT_UNENROLLMENT_COUNT_REQUEST,
  MAX_INSTRUMENT_UNENROLLMENT_COUNT_SUCCESS,
  MAX_INSTRUMENT_UNENROLLMENT_COUNT_ERROR
} from "Admin/store/AdminPageConstants";
import AppService from "Global/AppService";
import { serializeError } from "Common/utils/Utils";

const getRolesForUserInvoke = (url) => {
  console.log("data::::::::::", url);
  return (dispatch) => {
    function callback(success, err) {
      console.log({ success });
      if (success && success.result) {
        let rolesList = success.result;
        dispatch({ type: ROLES_OF_USER, newState: { rolesOfUser: rolesList } });
      }
    }
    AppService.getData(url, callback);
  };
};

const getInstGroupsForMapping = (url) => {
  return (dispatch) => {
    dispatch(getInstGroupsForMappingRequest());

    function callback(success, err) {
      if (success && success.result) {
        dispatch(getInstGroupsForMappingSuccess(success.result));
      } else {
        dispatch(getInstGroupsForMappingError(err));
      }
    }

    AppService.getData(url, callback);
  };
};

const getInstGroupsForMappingRequest = () => {
  return {
    type: INST_GROUPS_FOR_MAPPING_REQUEST,
  };
};

const getInstGroupsForMappingSuccess = (result) => {
  return {
    type: INST_GROUPS_FOR_MAPPING_SUCCESS,
    payload: result,
  };
};

const getInstGroupsForMappingError = (err) => {
  return {
    type: INST_GROUPS_FOR_MAPPING_ERROR,
    payload: serializeError(err),
  };
};

const getUserGroupsForMapping = (url) => {
  return (dispatch) => {
    dispatch(getUserGroupsForMappingRequest());

    function callback(success, err) {
      if (success && success.result) {
        dispatch(getUserGroupsForMappingSuccess(success.result));
      } else {
        dispatch(getUserGroupsForMappingError(err));
      }
    }

    AppService.getData(url, callback);
  };
};

const getUserGroupsForMappingRequest = () => {
  return {
    type: USER_GROUPS_FOR_MAPPING_REQUEST,
  };
};

const getUserGroupsForMappingSuccess = (result) => {
  return {
    type: USER_GROUPS_FOR_MAPPING_SUCCESS,
    payload: result,
  };
};

const getUserGroupsForMappingError = (err) => {
  return {
    type: USER_GROUPS_FOR_MAPPING_ERROR,
    payload: serializeError(err),
  };
};


const getMaxUnrollmentInstrumentCount = (url) => {
  return (dispatch) => {
    dispatch(getMaxUnrollmentInstrumentCountRequest());

    function callback(success, err) {
      if (success && success.result) {
        dispatch(getMaxUnrollmentInstrumentCountSuccess(success.result));
      } else {
        dispatch(getMaxUnrollmentInstrumentCountError(err));
      }
    }

    AppService.getData(url, callback);
  };
};

const getMaxUnrollmentInstrumentCountRequest = () => {
  return {
    type: MAX_INSTRUMENT_UNENROLLMENT_COUNT_REQUEST,
  };
};

const getMaxUnrollmentInstrumentCountSuccess = (result) => {
  return {
    type: MAX_INSTRUMENT_UNENROLLMENT_COUNT_SUCCESS,
    payload: result,
  };
};

const getMaxUnrollmentInstrumentCountError = (err) => {
  return {
    type: MAX_INSTRUMENT_UNENROLLMENT_COUNT_ERROR,
    payload: serializeError(err),
  };
};

export { getRolesForUserInvoke, getInstGroupsForMapping, getUserGroupsForMapping, getMaxUnrollmentInstrumentCount };
